import { tactonCommonAPI } from "./tacton";
var defaultAPI = tactonCommonAPI;
export default defaultAPI;
